import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type { DomainRecord, PaginatedResponse } from '@/lib/types'

interface DomainListParams {
  page?: number
  per_page?: number
  search?: string
  status?: string
  account?: string
  sort?: string
  direction?: string
}

const DOMAINS_KEY = ['domains'] as const

export function useDomains(
  params?: DomainListParams,
): ReturnType<typeof useQuery<PaginatedResponse<DomainRecord>>> {
  return useQuery({
    queryKey: [...DOMAINS_KEY, params],
    queryFn: () =>
      apiClient.get<PaginatedResponse<DomainRecord>>(
        endpoints.domains.list({
          page: params?.page,
          per_page: params?.per_page,
          search: params?.search,
          status: params?.status,
          account: params?.account,
          sort: params?.sort,
          direction: params?.direction,
        }),
      ),
  })
}

export function useReverifyDomain(): ReturnType<typeof useMutation<unknown, unknown, string>> {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => apiClient.post(endpoints.domains.reverify(id)),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: DOMAINS_KEY })
    },
  })
}
